import { getPreviewText } from '@/components/ui/TextareaWithVars/utils'

import type { CustomVars } from '@/components/ui/TextareaWithVars/interfaces'
import type { LoyaltyReward } from '@/types/types'

export const getCampaignPreviewText = (text: string, storeName: string, reward?: LoyaltyReward) => {
  const variables = getCustomVars({ storeName, reward })

  return getPreviewText(text, variables)
}

export const getCustomVars = ({
  storeName,
  reward,
  variablesLength,
  t
}: {
  storeName: string
  reward?: LoyaltyReward
  variablesLength?: Record<string, number>
  t?: (key: string) => string
}) => {
  const variables: CustomVars[] = [
    {
      type: 'variable',
      code: 'store',
      label: t ? t('global.customVars.store.name') : null,
      icon: 'IconoirShop',
      length: storeName.length,
      example: storeName
    },
    {
      type: 'webapp',
      code: 'qrcodeLink',
      label: t ? t('global.customVars.qrcodeLink.name') : null,
      icon: 'HeroQrCodeIconSolid',
      length: variablesLength?.qrcodeLink ?? 16,
      example: 'pngo.fr/qrcode'
    },
    {
      type: 'link',
      code: 'reviewLink',
      label: t ? t('global.customVars.reviewLink.name') : null,
      icon: 'HeroGlobeAltIconSolid',
      length: variablesLength?.reviewLink ?? 14,
      example: 'pngo.fr/review'
    },
    {
      type: 'link',
      code: 'customLink',
      label: t ? t('global.customVars.customLink.name') : null,
      icon: 'HeroGlobeAltIconSolid',
      length: variablesLength?.customLink ?? 13,
      example: 'pngo.fr/link',
      customValueType: 'link'
    },
    {
      type: 'webapp',
      code: 'customerApp',
      label: t ? t('global.customVars.customerApp.rewards.name') : null,
      icon: 'HeroGlobeAltIconSolid',
      length: variablesLength?.customerApp ?? 16,
      example: 'pngo.fr/webapp'
    },
    {
      type: 'webapp',
      code: 'customerApp(customer-profile)',
      label: t ? t('global.customVars.customerApp.customerProfile.name') : null,
      icon: 'HeroGlobeAltIconSolid',
      length: variablesLength?.customerApp ?? 16,
      example: 'pngo.fr/webapp'
    },
    {
      type: 'webapp',
      code: 'customerApp(wallet)',
      label: t ? t('global.customVars.customerApp.wallet.name') : null,
      icon: 'HeroGlobeAltIconSolid',
      length: variablesLength?.customerApp ?? 16,
      example: 'pngo.fr/webapp'
    },
    {
      type: 'webapp',
      code: 'customerApp(survey)',
      label: t ? t('global.customVars.customerApp.survey.name') : null,
      icon: 'HeroGlobeAltIconSolid',
      length: variablesLength?.customerApp ?? 16,
      example: 'pngo.fr/webapp',
      customValueType: 'pageId',
      customValueModel: 'survey'
    },
    {
      type: 'variable',
      code: 'reward',
      label: t ? t('global.customVars.reward.name') : null,
      icon: 'HeroGiftIconOutline',
      length: reward?.name?.length ?? 0,
      example: reward?.name,
      disabled: !reward?.name,
      disabledMessage: t ? t('global.customVars.reward.disabledMessage') : null
    },
    {
      type: 'webapp',
      code: 'rewardLink',
      label: t ? t('global.customVars.rewardLink.name') : null,
      icon: 'HeroGiftIconOutline',
      length: variablesLength?.rewardLink ?? 16,
      example: 'pngo.fr/reward',
      disabled: !reward,
      disabledMessage: t ? t('global.customVars.rewardLink.disabledMessage') : null
    },
    {
      type: 'variable',
      code: 'voucher',
      label: t ? t('global.customVars.voucher.name') : null,
      icon: 'HeroReceiptPercentIconSolid',
      length: 10,
      example: 'XXXXXXXXXX',
      disabled: !reward?.rewardType?.isVoucher,
      disabledMessage: t ? t('global.customVars.voucher.disabledMessageType') : null
    }
  ]

  return variables
}
